import React, { ReactNode } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import classNames from 'classnames';

import { AnchorProps, OptionalEngagementProps } from '@hcs/types';

import { addOptionalEngagementProps } from '../../../../utils/engagement-props.utils';

import styles from './Anchor.module.css';

export const Anchor = ({
  dataHcName,
  className,
  onClick,
  children,
  href,
  rel,
  target,
  type,
  disabled,
  size = 'lg',
  code,
  dark,
  flex,
  ...restProps
}: AnchorProps) => {
  return (
    <a
      data-hc-name={dataHcName}
      {...addOptionalEngagementProps(restProps)}
      className={classNames(styles.Anchor, className, {
        [styles.disabled]: disabled,
        [styles.sm]: size === 'sm',
        [styles.code]: !!code,
        [styles.dark]: !!dark,
        [styles.flex]: !!flex,
      })}
      onClick={!disabled ? onClick : undefined}
      href={!disabled ? href : undefined}
      type={type}
      target={target}
      {...(target === '_blank' ? { rel: 'noreferrer' } : { rel })}
    >
      {children}
    </a>
  );
};

export type LinkAnchorProps = LinkProps &
  Pick<AnchorProps, 'code' | 'dark' | 'flex'> & {
    dataHcName: string;
    children: ReactNode;
    className?: string;
    disabled?: boolean;
  } & OptionalEngagementProps;

export const LinkAnchor = ({
  dataHcName,
  children,
  className,
  disabled,
  code,
  dark,
  flex,
  ...restProps
}: LinkAnchorProps) => {
  return (
    <Link
      data-hc-name={dataHcName}
      {...addOptionalEngagementProps(restProps)}
      className={classNames(styles.Anchor, className, {
        [styles.disabled]: disabled,
        [styles.code]: !!code,
        [styles.dark]: !!dark,
        [styles.flex]: !!flex,
      })}
      {...restProps}
    >
      {children}
    </Link>
  );
};
